export enum BannerStatus {
  ENABLE = 'enable',
  DISABLE = 'disable',
}

export enum BannerType {
  IMAGE = 'image',
  VIDEO = 'video',
}

export enum BannerPosition {
  TOP = 'top',
  MIDDLE = 'middle',
  HEADER_TOP = 'header_top',
  // 게시글 상세 콘텐츠 최상단(제목 아래) 슬롯
  ARTICLE_TOP = 'article_top',
  MOBILE_ARTICLE_TOP = 'mobile_article_top',
  // 학원 리스트 검색창 아래 슬롯
  ACADEMY_SEARCH_TOP = 'academy_search_top',
}

export interface BannerEntity {
  id: number;
  userId: number;
  upfileId: number;
  articleId: number;
  title: string;
  description: string;
  position: BannerPosition;
  type: BannerType;
  status: BannerStatus;
  videoUrl: string;
  backgroundColor: string;
  href: string;
  sequence: number;
  registerDatetime: string;
  modifyDatetime: string;
  startDatetime: string;
  endDatetime: string;
  upfilePath: string;
}

export interface GetBannerListParams {
  position: BannerPosition;
}

export interface BannerListResponse {
  pc: BannerEntity[];
  mobile: BannerEntity[];
}

// 스토리 배너(게시글 상세 상단) 조회 파라미터
export interface GetStoryBannerParams {
  articleId?: number; // 글 단위 타겟
  boardType?: string; // 게시판 단위 타겟 (board.type)
}
